import React from 'react';

const MaintenanceScreen: React.FC = () => {
  return (
    <div className="min-h-screen theme-bg-secondary flex items-center justify-center">
      <div className="max-w-md mx-auto text-center p-8">
        {/* Maintenance Icon */}
        <div className="mb-8">
          <svg 
            className="w-24 h-24 mx-auto theme-text-muted" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={1.5} 
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" 
            />
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={1.5} 
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" 
            />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold theme-text mb-4">
          Under Maintenance
        </h1>

        {/* Description */}
        <p className="theme-text-secondary text-lg mb-6">
          We're currently performing scheduled maintenance to improve your experience. 
          We'll be back online shortly.
        </p>

        {/* Additional Info */}
        {/* <div className="theme-bg-tertiary rounded-lg p-4 mb-6">
          <p className="theme-text-muted text-sm">
            If you need immediate assistance, please contact our support team.
          </p>
        </div> */}

        {/* Loading Animation */}
        <div className="flex items-center justify-center space-x-2">
          <div className="animate-pulse w-2 h-2 theme-bg-primary rounded-full"></div>
          <div className="animate-pulse w-2 h-2 theme-bg-primary rounded-full" style={{ animationDelay: '0.2s' }}></div>
          <div className="animate-pulse w-2 h-2 theme-bg-primary rounded-full" style={{ animationDelay: '0.4s' }}></div>
        </div>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t theme-border">
          <p className="theme-text-muted text-xs">
            Thank you for your patience
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceScreen;
